import { useMemo } from 'react';

import { useActiveUserClasses } from 'src/hooks/use-active-user-classes';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { getAmpConfigFlags } from 'src/services/amp-config.service';
import AuthService from 'src/services/api/auth.service';
import { useGetTaughtLessonsQuery } from 'src/store/api/class-stats';
import {
  useActiveMSAssignmentsStatus,
  useActiveMSAssignmentsSubject,
  useActiveMSAssignmentsWorkType,
  useSelectedClassSelector,
} from 'src/store/features';

export const useTaughtLessons = () => {
  const activeMSAssignmentsSubject = useActiveMSAssignmentsSubject();
  const activeMSAssignmentsStatus = useActiveMSAssignmentsStatus();
  const activeMSAssignmentsWorkType = useActiveMSAssignmentsWorkType();

  const { activeUserClasses } = useActiveUserClasses();
  const selectedClass = useSelectedClassSelector();

  const isStudent = AuthService.isStudent();
  const isMiddleSchoolView = useIsMiddleSchoolView();

  // TODO: Remove the feature flag after RFS.
  const isUpdatedMSViewEnabled = getAmpConfigFlags().isUpdatedMSViewEnabled;

  const isTodoMSView = isUpdatedMSViewEnabled && !!activeMSAssignmentsWorkType;

  const shouldSkipQueryMSView =
    isMiddleSchoolView && (isTodoMSView || !!activeMSAssignmentsStatus);

  const relevantClassBk = useMemo(() => {
    const areAllClassesSelected = !!selectedClass && selectedClass.length > 1;

    if (isStudent || areAllClassesSelected) {
      return activeUserClasses?.map((cl) => cl.sourcedId) ?? '';
    }

    return selectedClass?.[0].sourcedId ?? '';
  }, [isStudent, activeUserClasses, selectedClass]);

  const shouldSkipQuery = shouldSkipQueryMSView || !relevantClassBk.length;

  const { isLoading, ...rest } = useGetTaughtLessonsQuery(
    {
      domain: activeMSAssignmentsSubject,
      classBk: relevantClassBk,
    },
    { skip: shouldSkipQuery },
  );

  return { isLoading: !rest.error && isLoading, ...rest };
};
